export const EVENTS_TRACKING = {
    AGREEMENT_SIGNED:'agreement_signed',
    AGREEMENT_STATUS:'agreement_status'
}

export const timestamp = new Date().toISOString();